import { render, staticRenderFns } from "./oneStopProcessing.vue?vue&type=template&id=afd60688&scoped=true&"
import script from "./oneStopProcessing.vue?vue&type=script&lang=js&"
export * from "./oneStopProcessing.vue?vue&type=script&lang=js&"
import style0 from "./oneStopProcessing.vue?vue&type=style&index=0&id=afd60688&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd60688",
  null
  
)

export default component.exports